/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getPlans() {
    return axios.get(`${this.baseUrl()}/billing/plans`);
  }

  validateVoucher(code) {
    return axios.post(`${this.baseUrl()}/billing/voucher/validate`, { code });
  }

  getSubscription() {
    return axios.get(`${this.baseUrl()}/billing/subscription`);
  }

  getInvoices() {
    return axios.get(`${this.baseUrl()}/billing/invoices`);
  }

  getInvoice(id) {
    return axios.get(`${this.baseUrl()}/billing/invoices/${id}`);
  }

  applyVoucher(invoiceId, code) {
    return axios.post(
      `${this.baseUrl()}/billing/invoices/${invoiceId}/apply_voucher`,
      { code }
    );
  }

  createCheckout(payload) {
    return axios.post(`${this.baseUrl()}/billing/checkout`, payload);
  }

  previewSeatAddition(payload) {
    return axios.post(
      `${this.baseUrl()}/billing/seat_changes/preview`,
      payload
    );
  }

  createSeatAddition(payload) {
    return axios.post(`${this.baseUrl()}/billing/seat_changes`, payload);
  }

  reduceSeats(payload) {
    return axios.delete(`${this.baseUrl()}/billing/seat_changes`, {
      data: payload,
    });
  }

  createKashirCheckout(payload = {}) {
    return axios.post(`${this.baseUrl()}/billing/kashir_checkout`, payload);
  }

  confirmKashirReturn(payload) {
    return axios.post(`${this.baseUrl()}/billing/kashir_return`, payload);
  }

  abandonCheckout(payload) {
    return axios.post(`${this.baseUrl()}/billing/abandon_checkout`, payload);
  }

  getAiCredits() {
    return axios.get(`${this.baseUrl()}/billing/ai_credits`);
  }

  purchaseAiCredits(amount) {
    return axios.post(`${this.baseUrl()}/billing/ai_credits/purchase`, {
      amount,
    });
  }
}

export default new BillingAPI();
